import { Toaster } from 'sonner';
import { useConfigStore } from './stores/configStore';

export const WelmProvider = ({ apiUrl, children }) => {
  const { apiUrl: current, setApiUrl } = useConfigStore.getState();
  if (apiUrl && apiUrl !== current) setApiUrl(apiUrl);

  return <>{children}<Toaster /></>;
};
